import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, map, Observable, shareReplay } from 'rxjs';

export function queryParam$(
  route: ActivatedRoute,
  param: string,
): Observable<string> {
  return route.queryParams.pipe(
    map((params) => params[param]),
    distinctUntilChanged(),
    shareReplay(1),
  );
}

export function param$(
  route: ActivatedRoute,
  param: string,
): Observable<string> {
  return route.params.pipe(
    map((params) => params[param]),
    distinctUntilChanged(),
    shareReplay(1),
  );
}
